import React, { useCallback, useState } from 'react';
import Checkbox from '../../../../Checkbox';
import s from './ModalDoNotShowAgain.scss';

interface Props {
  doNotShowAgainText: string;
  onDoNotShowAgainChange: (value) => void;
}

/** Control for the do not show again feature of confirm modals */
const ModalDoNotShowAgain: React.FC<Props> = ({
  onDoNotShowAgainChange,
  doNotShowAgainText,
}) => {
  const [checked, setChecked] = useState(false);
  const onChange = useCallback(
    value => {
      setChecked(value);
      onDoNotShowAgainChange(value);
    },
    [onDoNotShowAgainChange]
  );
  return (
    <div className={s['root']}>
      <Checkbox
        onChange={onChange}
        isChecked={checked}
        labelClassName={s['label']}
      >
        {doNotShowAgainText}
      </Checkbox>
    </div>
  );
};
ModalDoNotShowAgain.displayName = 'ModalDoNotShowAgain';

export default ModalDoNotShowAgain;
